import WorkCard from "../components/WorkCard";
import { FadeUp, MaskedLine } from "../components/Reveal";
import { caseStudies } from "../data/content";

export default function Work() {
  return (
    <div className="pt-32 md:pt-44">
      <header className="mx-auto max-w-7xl px-6">
        <p className="font-mono text-[11px] uppercase tracking-[0.25em] text-blue">
          Work — Index
        </p>
        <h1 className="mt-6 font-display font-extrabold leading-[0.95] tracking-[-0.03em] text-[clamp(3rem,9vw,8rem)]">
          <MaskedLine delay={0.15}>SELECTED</MaskedLine>
          <MaskedLine delay={0.28}>
            <span className="text-blue">PROBLEMS.</span>
          </MaskedLine>
        </h1>
        <FadeUp delay={0.35}>
          <p className="mt-8 max-w-xl text-base leading-relaxed text-smoke md:text-lg">
            Campaigns and platforms across healthcare, automotive, FMCG, durables and
            financial services — each one built from a reframed brief. Executed work is
            labelled as such; proposals are labelled as proposals.
          </p>
        </FadeUp>
      </header>

      <section className="mx-auto max-w-7xl px-6 pb-28 pt-16 md:pt-20">
        <div className="grid gap-x-10 gap-y-20 md:grid-cols-2">
          {caseStudies.map((study, i) => (
            <FadeUp key={study.slug} className={i % 2 === 1 ? "md:translate-y-16" : ""}>
              <WorkCard study={study} index={i} />
            </FadeUp>
          ))}
        </div>
      </section>
    </div>
  );
}
